import apiClient from "../../axios/apiClient";


export const getProvisionalTripReportList =
  (token, limit = 10, page = 1, search = "", sort = "desc", jenId = "", vendorId = "", 
    vehicleId = "", driverId = "", startDate = "", endDate = "") =>
  async (dispatch) => {
    try
    {
      dispatch({ type: "GET_PROVISIONAL_TRIP_REPORT_PENDING" });

      const params = {
        limit: limit,
        page: page,
        search: search,
        sort: sort,
        vendorId: vendorId,
        vehicleId: vehicleId,
        driverId: driverId,
        startDate: startDate,
        endDate: endDate,
      };

      // Only include jenId if it has a value
      if (jenId) {
        params.jenId = jenId;
      }

      const response = await apiClient.get(
        `/api/v1/provisional-report/trip`,
        {
          params: params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_PROVISIONAL_TRIP_REPORT_FULFILLED",
        payload: response.data?.data,
        reportCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    }
    catch (error)
    {
      dispatch({
        type: "GET_PROVISIONAL_TRIP_REPORT_REJECTED",
        payload: error.response,
      });
    }
  };


export const getProvisionalRevenueReportList =
  (token, limit = 10, page = 1, search = "", sort = "desc", jenId = "", vendorId = "", 
    vehicleId = "", driverId = "", startDate = "", endDate = "") =>
  async (dispatch) => {
    try
    {
      dispatch({ type: "GET_PROVISIONAL_REVENUE_REPORT_PENDING" });

      const params = {
        limit: limit,
        page: page,
        search: search,
        sort: sort,
        vendorId: vendorId,
        vehicleId: vehicleId,
        driverId: driverId,
        startDate: startDate,
        endDate: endDate,
      };

      // Only include jenId if it has a value
      if (jenId) {
        params.jenId = jenId;
      }

      const response = await apiClient.get(
        `/api/v1/provisional-report/revenue`,
        {
          params: params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_PROVISIONAL_REVENUE_REPORT_FULFILLED",
        payload: response.data?.data,
        reportCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    }
    catch (error)
    {
      dispatch({
        type: "GET_PROVISIONAL_REVENUE_REPORT_REJECTED",
        payload: error.response,
      });
    }
  };


export const getProvisionalMonthlyRevenueReportList =
  (token, limit = 10, page = 1, search = "", sort = "desc", jenId = "", vendorId = "", 
    vehicleId = "", driverId = "", startDate = "", endDate = "") =>
  async (dispatch) => {
    try
    {
      dispatch({ type: "GET_PROVISIONAL_MONTHLY_REVENUE_REPORT_PENDING" });

      const params = {
        limit: limit,
        page: page,
        search: search,
        sort: sort,
        vendorId: vendorId,
        vehicleId: vehicleId,
        driverId: driverId,
        startDate: startDate,
        endDate: endDate,
      };

      // Only include jenId if it has a value
      if (jenId) {
        params.jenId = jenId;
      }

      const response = await apiClient.get(
        `/api/v1/provisional-report/monthly-revenue`,
        {
          params: params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_PROVISIONAL_MONTHLY_REVENUE_REPORT_FULFILLED",
        payload: response.data?.data,
        reportCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    }
    catch (error)
    {
      dispatch({
        type: "GET_PROVISIONAL_MONTHLY_REVENUE_REPORT_REJECTED",
        payload: error.response,
      });
    }
  };



  export const getProvisionalWaterReportList =
  (token, limit = 10, page = 1, search = "", sort = "desc", jenId = "", vendorId = "", 
    vehicleId = "", driverId = "", startDate = "", endDate = "") =>
  async (dispatch) => {
    try
    {
      dispatch({ type: "GET_PROVISIONAL_TRIP_REPORT_PENDING" });
      const params = {
        limit: limit,
        page: page,
        search: search,
        sort: sort,
        jenId:jenId,
        vendorId: vendorId,
        vehicleId: vehicleId,
        driverId: driverId,
        startDate: startDate,
        endDate: endDate,
      };
      if (jenId) {
        params.jenId = jenId;
      }
      const response = await apiClient.get(
        `/api/v1/other-report/water-report`,
        {
          params: params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_PROVISIONAL_TRIP_REPORT_FULFILLED",
        payload: response.data?.data,
        reportCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    }
    catch (error)
    {
      dispatch({
        type: "GET_PROVISIONAL_TRIP_REPORT_REJECTED",
        payload: error.response,
      });
    }
  };
